import React from "react";
import styles from "../../Styles/Password.Trigger.module.scss";
import FindLangKey from "Global/Functions/FindLangKey/FindLangKey";
const PasswordResetTrigger = ({ setter,ResetTrigger }) => {

  const resetPass_msg = FindLangKey("login-link-forgot-password");
  const login_msg = FindLangKey("login-button-enter")

  return (
    <h5
      className={styles.ResetPasswordHeading}
      onClick={() => setter((prev) => !prev)}
    >
     {ResetTrigger?login_msg:resetPass_msg}
    </h5>
  );
};

export default PasswordResetTrigger;
